import React from "react";
import ReactDOM from  "react-dom";
import { wrapCurrentUser } from "../../mixins/wrap_current_user";
import Template from "./account_signup_modal.rt";
import { subscribe, createAccount } from "../../gateway/backend";

@wrapCurrentUser
export default class AccountSignUpModal extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.getButtonText = this.getButtonText.bind(this);
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  getButtonText() {
    const buttonText = this.props.planAccountSignup ? 'pay now' : 'get started';
    return buttonText;
  }

  render() {
    return Template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/account_signup_modal.js